<template>
    <div id="app">
      <v-app>
        <the-loading v-show="isWaiting"></the-loading>
          <router-view></router-view>
      </v-app>
    </div>
</template>
<script>
import TheLoading from '@/components/TheLoading.vue';
// import Watermark from '@/utils/watermark'
export default {
  components: { TheLoading },
  data () {
    return { }
  },
  computed: {
    isWaiting () {
      return this.$store.getters.isWaiting
    },
    isLogin () {
      return this.$store.getters['user/isLogin']
    },
    userInfo () {
      return this.$store.getters['user/info']
    },
  },
  created () {},
  mounted () {
    // 先不開啟浮水印
    // Watermark.start()
    document.oncontextmenu = () => { return false }  //鎖右鍵
    document.onkeydown = (event) => { //鎖ctrl +P 或ctrl +S
      if (event !== null) {
        if (event.ctrlKey || event.metaKey) {
          if (event.code === 'KeyS' || event.code === 'KeyP' ||
          event.keyCode === 80 || event.keyCode === 83) {
            return false
          }
        }
      }
    }
  },
  destroyed () {
    // 先不開啟浮水印
    // Watermark.remove()
  }
}
</script>
